import { format, parseISO } from 'date-fns';

export function formatParsedISO(date, fmt = 'dd/MM/yyyy', fallback = '') {
  try {
    return format(parseISO(date as string), fmt);
  } catch (e) {
    return fallback;
  }
}
